import * as React from 'react';

export const joFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_397)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_397'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_397)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill='#007B3A'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V6.66667H0V0Z'
                    fill='#151515'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0V20.044L17.3333 10L0 0Z'
                    fill='#CF0921'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M4 10L5.33333 9.33333L6 8L6.66667 9.33333L8 10L6.66667 10.6667L6 12L5.33333 10.6667L4 10Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_397'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
